import yup from 'src/utils/yup';
import createTypedAction from '../createTypedAction';

export const PREFIX = '@@fox/dashboard/';

export const { fetchDeviceNav, FETCH_DEVICE_NAV }: any = createTypedAction(
  `${PREFIX}FETCH_DEVICE_NAV`,
  ['tab', yup.string().required()],
  ['selectedFilters', yup.immutable().map()]
);

export const { fetchDeviceNavSuccess, FETCH_DEVICE_NAV_SUCCESS }: any = createTypedAction(
  `${PREFIX}FETCH_DEVICE_NAV_SUCCESS`,
  ['nav', yup.object().required()]
);

export const { fetchDeviceNavFailed, FETCH_DEVICE_NAV_FAILED }: any = createTypedAction(
  `${PREFIX}FETCH_DEVICE_NAV_FAILED`,
  ['err', yup.object().nullable()]
);

export const { openAddConnection, OPEN_ADD_CONNECTION }: any = createTypedAction(
  `${PREFIX}OPEN_ADD_CONNECTION`
);

export const { closeAddConnection, CLOSE_ADD_CONNECTION }: any = createTypedAction(
  `${PREFIX}CLOSE_ADD_CONNECTION`
);

export const { createConnection, CREATE_CONNECTION }: any = createTypedAction(
  `${PREFIX}CREATE_CONNECTION`,
  ['commLoop', yup.object().required()]
);

export const { createConnectionSuccess, CREATE_CONNECTION_SUCCESS }: any = createTypedAction(
  `${PREFIX}CREATE_CONNECTION_SUCCESS`,
  ['connection', yup.immutable().map().required()]
);

export const { createConnectionFailed, CREATE_CONNECTION_FAILED }: any = createTypedAction(
  `${PREFIX}CREATE_CONNECTION_FAILED`,
  ['err', yup.object().nullable()]
);
